import { render, staticRenderFns } from "./BadWordHeaderAnalyse.vue?vue&type=template&id=3804ea99&"
import script from "./BadWordHeaderAnalyse.vue?vue&type=script&lang=js&"
export * from "./BadWordHeaderAnalyse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports